/**
 * Airship Privacy Manager.
 */
export class AirshipPrivacyManager {
    constructor(plugin) {
        this.plugin = plugin;
    }
    /**
     * Sets the current set of enabled features.
     * @param features The features to set.
     * @returns A promise.
     */
    setEnabledFeatures(features) {
        return this.plugin.perform('privacyManager#setEnabledFeatures', features);
    }
    /**
     * Gets the current enabled features.
     * @returns A promise with the result.
     */
    getEnabledFeatures() {
        return this.plugin.perform('privacyManager#getEnabledFeatures');
    }
    /**
     * Enables additional features.
     * @param features The features to enable.
     * @returns A promise.
     */
    enableFeatures(features) {
        return this.plugin.perform('privacyManager#enableFeatures', features);
    }
    /**
     * Disable features.
     * @param features The features to disable.
     * @returns A promise.
     */
    disableFeatures(features) {
        return this.plugin.perform('privacyManager#disableFeatures', features);
    }
    /**
     * Checks if the features are enabled or not.
     * @param features The features to check.
     * @returns A promise with the result.
     */
    isFeaturesEnabled(features) {
        return this.plugin.perform('privacyManager#isFeaturesEnabled', features);
    }
}
//# sourceMappingURL=AirshipPrivacyManager.js.map